import React from 'react';
import { ProcessForm } from '../ovz-facility-request-operator-change-types';

export function StepSummaryLabel({ allValues }: { allValues?: ProcessForm }) {
  const state = allValues?.isSent ? 'ČEKÁ NA SCHVÁLENÍ' : 'NEODESLÁNO';

  return (
    <>
      Stav nabídky: <b>{state}</b>
    </>
  );
}
